import axios from 'axios'
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/etc/env'

const { VUE_APP_AI_BACKEND } = process.env
console.log({ VUE_APP_AI_BACKEND })

export const Api = axios.create({
  baseUrl: VUE_APP_AI_BACKEND
})

export const Ai = (jwt) => axios.create({
  baseUrl: VUE_APP_AI_BACKEND + '/vbapi/',
  headers: {
    Authorization: `Bearer ${jwt}`
  }
})

export const AiApi = async (jwt, endpoint, data) => {
  try {
    const rep = await Ai(jwt).request({
      method: 'post',
      url: VUE_APP_AI_BACKEND + '/vbapi/' + endpoint,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })
    console.log('AiApi::rep', rep)
    return rep.data
  } catch (err) {
    console.error('api error', err)
  }
  return null
}

export const FnApi = axios.create({
  baseUrl: `${SUPABASE_URL}/functions/v1`,
  headers: {
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`
  }
})
